// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var Scalars = require("../../../scalars/Scalars.bs.js");
var V4 = require("uuid/v4");
var DateFnsTz = require("../../../reason/common/DateFns/DateFnsTz.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var UserSession = require("../../../reason/common/UserSession/UserSession.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RelayRuntime = require("relay-runtime");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Query = require("rescript-relay/src/RescriptRelay_Query.bs.js");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var PropertyWizardRelay__Preview__Query = require("./PropertyWizardRelay__Preview__Query.bs.js");
var PropertyWizardFormRelayQuery_graphql = require("../../../__generated__/PropertyWizardFormRelayQuery_graphql.bs.js");
var PropertyWizardFormRelayMutation_graphql = require("../../../__generated__/PropertyWizardFormRelayMutation_graphql.bs.js");
var PropertyWizardFormRelay_localDraft_graphql = require("../../../__generated__/PropertyWizardFormRelay_localDraft_graphql.bs.js");
var PropertyWizardFormRelay_serverDraft_graphql = require("../../../__generated__/PropertyWizardFormRelay_serverDraft_graphql.bs.js");
var PropertyWizardFormRelayFormStateQuery_graphql = require("../../../__generated__/PropertyWizardFormRelayFormStateQuery_graphql.bs.js");
var PropertyWizardFormRelay_inlineServerDraft_graphql = require("../../../__generated__/PropertyWizardFormRelay_inlineServerDraft_graphql.bs.js");
var PropertyWizardFormRelayBroadcastPolicy_policy_graphql = require("../../../__generated__/PropertyWizardFormRelayBroadcastPolicy_policy_graphql.bs.js");
var PropertyWizardFormRelayFormStateUpdatableQuery_graphql = require("../../../__generated__/PropertyWizardFormRelayFormStateUpdatableQuery_graphql.bs.js");

var convertFragment = PropertyWizardFormRelayBroadcastPolicy_policy_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelayBroadcastPolicy_policy_graphql.node, convertFragment, fRef);
}

function readInline(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertyWizardFormRelayBroadcastPolicy_policy_graphql.node, convertFragment, fRef);
}

var PolicyFragment_broadcastNotAllowedReason_decode = PropertyWizardFormRelayBroadcastPolicy_policy_graphql.Utils.broadcastNotAllowedReason_decode;

var PolicyFragment_broadcastNotAllowedReason_fromString = PropertyWizardFormRelayBroadcastPolicy_policy_graphql.Utils.broadcastNotAllowedReason_fromString;

var PolicyFragment = {
  broadcastNotAllowedReason_decode: PolicyFragment_broadcastNotAllowedReason_decode,
  broadcastNotAllowedReason_fromString: PolicyFragment_broadcastNotAllowedReason_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  readInline: readInline
};

var convertVariables = PropertyWizardFormRelayFormStateQuery_graphql.Internal.convertVariables;

var convertResponse = PropertyWizardFormRelayFormStateQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse = PropertyWizardFormRelayFormStateQuery_graphql.Internal.convertWrapRawResponse;

var use = RescriptRelay_Query.useQuery(convertVariables, PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse);

var useLoader = RescriptRelay_Query.useLoader(convertVariables, PropertyWizardFormRelayFormStateQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded = RescriptRelay_Query.usePreloaded(PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse, (function (prim) {
        return prim;
      }));

var $$fetch = RescriptRelay_Query.$$fetch(PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse, convertVariables);

var fetchPromised = RescriptRelay_Query.fetchPromised(PropertyWizardFormRelayFormStateQuery_graphql.node, convertResponse, convertVariables);

var retain = RescriptRelay_Query.retain(PropertyWizardFormRelayFormStateQuery_graphql.node, convertVariables);

var commitLocalPayload = RescriptRelay_Query.commitLocalPayload(PropertyWizardFormRelayFormStateQuery_graphql.node, convertVariables, convertWrapRawResponse);

var Query = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapRawResponse,
  use: use,
  useLoader: useLoader,
  usePreloaded: usePreloaded,
  $$fetch: $$fetch,
  fetchPromised: fetchPromised,
  retain: retain,
  commitLocalPayload: commitLocalPayload
};

var UpdatableQuery = {
  Types: undefined,
  readUpdatableQuery: PropertyWizardFormRelayFormStateUpdatableQuery_graphql.readUpdatableQuery
};

function setDisplayNeighborhoods(parent, displayNeighborhoods) {
  parent.displayNeighborhoods = displayNeighborhoods.map(function (d) {
        return {
                __id: d.__id
              };
      });
}

function useUpdater() {
  var environment = RescriptRelay.useEnvironmentFromContext();
  return React.useCallback((function (updater) {
                RelayRuntime.commitLocalUpdate(environment, (function (store) {
                        var match = PropertyWizardFormRelayFormStateUpdatableQuery_graphql.readUpdatableQuery(store, undefined);
                        var formState = match.updatableData.localDraftFormState;
                        if (formState === null || formState === undefined) {
                          return ;
                        } else {
                          return updater(formState);
                        }
                      }));
              }), [environment]);
}

var FormState = {
  Query: Query,
  UpdatableQuery: UpdatableQuery,
  setDisplayNeighborhoods: setDisplayNeighborhoods,
  useUpdater: useUpdater
};

var draftV5Status_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.draftV5Status_decode;

var convertFragment$1 = PropertyWizardFormRelay_localDraft_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelay_localDraft_graphql.node, convertFragment$1, fRef);
}

var LocalDraftFragment_draftV5Status_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.draftV5Status_fromString;

var LocalDraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var LocalDraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var LocalDraftFragment_leaseLengthValue_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.leaseLengthValue_decode;

var LocalDraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.leaseLengthValue_fromString;

var LocalDraftFragment_localDraftPropertyType_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.localDraftPropertyType_decode;

var LocalDraftFragment_localDraftPropertyType_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.localDraftPropertyType_fromString;

var LocalDraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.mlsListingTypeV5_decode;

var LocalDraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.mlsListingTypeV5_fromString;

var LocalDraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var LocalDraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var LocalDraftFragment_showingTypeV5_decode = PropertyWizardFormRelay_localDraft_graphql.Utils.showingTypeV5_decode;

var LocalDraftFragment_showingTypeV5_fromString = PropertyWizardFormRelay_localDraft_graphql.Utils.showingTypeV5_fromString;

var LocalDraftFragment = {
  draftV5Status_decode: draftV5Status_decode,
  draftV5Status_fromString: LocalDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: LocalDraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: LocalDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: LocalDraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: LocalDraftFragment_leaseLengthValue_fromString,
  localDraftPropertyType_decode: LocalDraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftFragment_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: LocalDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: LocalDraftFragment_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: LocalDraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: LocalDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: LocalDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: LocalDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

var forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var leaseLengthValue_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.leaseLengthValue_decode;

var rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var convertFragment$2 = PropertyWizardFormRelay_serverDraft_graphql.Internal.convertFragment;

function waitForFragmentData$2(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2, fRef);
}

function use$2(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardFormRelay_serverDraft_graphql.node, convertFragment$2, fRef);
}

var ServerDraftFragment_draftV5Status_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.draftV5Status_decode;

var ServerDraftFragment_draftV5Status_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.draftV5Status_fromString;

var ServerDraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var ServerDraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.leaseLengthValue_fromString;

var ServerDraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.mlsListingTypeV5_decode;

var ServerDraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.mlsListingTypeV5_fromString;

var ServerDraftFragment_onOrOffV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.onOrOffV5_decode;

var ServerDraftFragment_onOrOffV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.onOrOffV5_fromString;

var ServerDraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var ServerDraftFragment_showingTypeV5_decode = PropertyWizardFormRelay_serverDraft_graphql.Utils.showingTypeV5_decode;

var ServerDraftFragment_showingTypeV5_fromString = PropertyWizardFormRelay_serverDraft_graphql.Utils.showingTypeV5_fromString;

var ServerDraftFragment = {
  draftV5Status_decode: ServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: ServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: ServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: leaseLengthValue_decode,
  leaseLengthValue_fromString: ServerDraftFragment_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: ServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: ServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: ServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: ServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: ServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: ServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$2,
  waitForFragmentData: waitForFragmentData$2,
  use: use$2,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

var convertFragment$3 = PropertyWizardFormRelay_inlineServerDraft_graphql.Internal.convertFragment;

function waitForFragmentData$3(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardFormRelay_inlineServerDraft_graphql.node, convertFragment$3, fRef);
}

function readInline$1(fRef) {
  return RescriptRelay_Fragment.readInlineData(PropertyWizardFormRelay_inlineServerDraft_graphql.node, convertFragment$3, fRef);
}

var InlineServerDraftFragment_draftV5Status_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.draftV5Status_decode;

var InlineServerDraftFragment_draftV5Status_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.draftV5Status_fromString;

var InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var InlineServerDraftFragment_leaseLengthValue_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.leaseLengthValue_decode;

var InlineServerDraftFragment_leaseLengthValue_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.leaseLengthValue_fromString;

var InlineServerDraftFragment_mlsListingTypeV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.mlsListingTypeV5_decode;

var InlineServerDraftFragment_mlsListingTypeV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.mlsListingTypeV5_fromString;

var InlineServerDraftFragment_onOrOffV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.onOrOffV5_decode;

var InlineServerDraftFragment_onOrOffV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.onOrOffV5_fromString;

var InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var InlineServerDraftFragment_showingTypeV5_decode = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.showingTypeV5_decode;

var InlineServerDraftFragment_showingTypeV5_fromString = PropertyWizardFormRelay_inlineServerDraft_graphql.Utils.showingTypeV5_fromString;

var InlineServerDraftFragment = {
  draftV5Status_decode: InlineServerDraftFragment_draftV5Status_decode,
  draftV5Status_fromString: InlineServerDraftFragment_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: InlineServerDraftFragment_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: InlineServerDraftFragment_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: InlineServerDraftFragment_leaseLengthValue_decode,
  leaseLengthValue_fromString: InlineServerDraftFragment_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: InlineServerDraftFragment_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: InlineServerDraftFragment_mlsListingTypeV5_fromString,
  onOrOffV5_decode: InlineServerDraftFragment_onOrOffV5_decode,
  onOrOffV5_fromString: InlineServerDraftFragment_onOrOffV5_fromString,
  rentalPropertyTypeEnumV5_decode: InlineServerDraftFragment_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: InlineServerDraftFragment_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: InlineServerDraftFragment_showingTypeV5_decode,
  showingTypeV5_fromString: InlineServerDraftFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$3,
  waitForFragmentData: waitForFragmentData$3,
  readInline: readInline$1
};

function serverDraftToLocalDraft(serverDraft) {
  var match = serverDraft.chapter;
  var tmp;
  if (match !== undefined) {
    var match$1 = match.preferences;
    if (match$1 !== undefined) {
      var match$2 = match$1.mlsComingSoon;
      tmp = match$2 !== undefined && (match$2 === "OFF" || match$2 === "ON") && match$2 !== "OFF" ? true : false;
    } else {
      tmp = false;
    }
  } else {
    tmp = false;
  }
  var draftProperty = serverDraft.draftProperty;
  var tmp$1;
  if (draftProperty !== undefined) {
    var propertyData = draftProperty.propertyData;
    var commission;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
            commission = propertyData.commission;
            break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
            commission = undefined;
            break;
        
      }
    } else {
      commission = undefined;
    }
    var match$3 = draftProperty.price;
    var match$4;
    if (match$3 !== undefined) {
      switch (match$3.__typename) {
        case "DraftPropertyPriceRange" :
            match$4 = [
              Core__Option.map(match$3.minPrice, (function (p) {
                      return p.value;
                    })),
              Core__Option.map(match$3.maxPrice, (function (p) {
                      return p.value;
                    })),
              true
            ];
            break;
        case "DraftPropertyExactPrice" :
        case "__unselected" :
            match$4 = [
              undefined,
              undefined,
              false
            ];
            break;
        
      }
    } else {
      match$4 = [
        undefined,
        undefined,
        false
      ];
    }
    var match$5 = draftProperty.price;
    var price;
    if (match$5 !== undefined) {
      switch (match$5.__typename) {
        case "DraftPropertyExactPrice" :
            price = Core__Option.map(match$5.price, (function (p) {
                    return p.value;
                  }));
            break;
        case "DraftPropertyPriceRange" :
        case "__unselected" :
            price = undefined;
            break;
        
      }
    } else {
      price = undefined;
    }
    var match$6;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
            match$6 = [
              propertyData.availableFrom,
              propertyData.leaseLength
            ];
            break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
            match$6 = [
              undefined,
              undefined
            ];
            break;
        
      }
    } else {
      match$6 = [
        undefined,
        undefined
      ];
    }
    var match$7 = draftProperty.displayNeighborhood;
    var tmp$2;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataForSaleV5" :
            tmp$2 = Core__Option.flatMap(propertyData.forSalePropertyType, forSalePropertyTypeEnumV5_decode);
            break;
        case "DraftPropertyDataRentalV5" :
        case "__unselected" :
            tmp$2 = undefined;
            break;
        
      }
    } else {
      tmp$2 = undefined;
    }
    var match$8 = draftProperty.geocodingData;
    var tmp$3;
    if (match$8 !== undefined) {
      var lat = match$8.lat;
      if (lat !== undefined) {
        var lon = match$8.lon;
        if (lon !== undefined) {
          var standardizedAddress = match$8.standardizedAddress;
          if (standardizedAddress !== undefined) {
            var standardizedCity = match$8.standardizedCity;
            if (standardizedCity !== undefined) {
              var standardizedState = match$8.standardizedState;
              if (standardizedState !== undefined) {
                var standardizedZip = match$8.standardizedZip;
                tmp$3 = standardizedZip !== undefined ? ({
                      lat: lat,
                      lon: lon,
                      standardizedAddress: standardizedAddress,
                      standardizedCity: standardizedCity,
                      standardizedState: standardizedState,
                      standardizedZip: standardizedZip
                    }) : undefined;
              } else {
                tmp$3 = undefined;
              }
            } else {
              tmp$3 = undefined;
            }
          } else {
            tmp$3 = undefined;
          }
        } else {
          tmp$3 = undefined;
        }
      } else {
        tmp$3 = undefined;
      }
    } else {
      tmp$3 = undefined;
    }
    var tmp$4;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
            tmp$4 = "RENTAL";
            break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
            tmp$4 = "FOR_SALE";
            break;
        
      }
    } else {
      tmp$4 = "FOR_SALE";
    }
    var tmp$5;
    if (propertyData !== undefined) {
      switch (propertyData.__typename) {
        case "DraftPropertyDataRentalV5" :
            tmp$5 = Core__Option.flatMap(propertyData.rentalPropertyType, rentalPropertyTypeEnumV5_decode);
            break;
        case "DraftPropertyDataForSaleV5" :
        case "__unselected" :
            tmp$5 = undefined;
            break;
        
      }
    } else {
      tmp$5 = undefined;
    }
    var match$9 = draftProperty.userSelectedArea;
    tmp$1 = {
      address: draftProperty.address,
      addressToGeocode: draftProperty.address,
      availableFrom: match$6[0],
      baths: draftProperty.baths,
      beds: draftProperty.beds,
      commission: commission,
      description: draftProperty.description,
      displayNeighborhood: match$7 !== undefined ? ({
            id: match$7.id,
            label: match$7.label
          }) : undefined,
      files: Core__Option.getOr(Core__Option.map(draftProperty.files, (function (files) {
                  return Core__Array.filterMap(files, (function (f) {
                                var contentType = f.contentType;
                                if (contentType === undefined) {
                                  return ;
                                }
                                var fileName = f.fileName;
                                if (fileName !== undefined) {
                                  return {
                                          contentType: contentType,
                                          fileName: fileName,
                                          id: f.id,
                                          key: f.key
                                        };
                                }
                                
                              }));
                })), []),
      forSalePropertyType: tmp$2,
      geocodingData: tmp$3,
      goingOnMls: draftProperty.goingOnMls,
      halfBaths: draftProperty.halfBaths,
      hideAddress: draftProperty.hideAddress,
      images: Core__Option.getOr(Core__Option.map(draftProperty.images, (function (images) {
                  return Core__Array.filterMap(images, (function (img) {
                                var contentType = img.contentType;
                                if (contentType === undefined) {
                                  return ;
                                }
                                var fileName = img.fileName;
                                if (fileName !== undefined) {
                                  return {
                                          contentType: contentType,
                                          fileName: fileName,
                                          id: img.id,
                                          key: img.key,
                                          previewUrl: img.url
                                        };
                                }
                                
                              }));
                })), []),
      leaseLength: Core__Option.flatMap(Core__Option.map(match$6[1], (function (p) {
                  return p.value;
                })), leaseLengthValue_decode),
      livingArea: draftProperty.livingArea,
      lotSize: draftProperty.lotSize,
      maxPrice: match$4[1],
      minPrice: match$4[0],
      mlsListingType: draftProperty.mlsListingType,
      numberOfUnits: draftProperty.numberOfUnits,
      onMlsAt: draftProperty.onMlsAt,
      price: price,
      priceRange: match$4[2],
      propertyType: tmp$4,
      rentalPropertyType: tmp$5,
      selectedArea: match$9 !== undefined ? ({
            id: match$9.id,
            label: match$9.label
          }) : undefined,
      showings: Core__Option.getOr(Core__Option.map(draftProperty.showings, (function (showings) {
                  return showings.map(function (s) {
                              var match = s.id;
                              var match$1 = s.key;
                              return {
                                      date: s.date,
                                      endTime: s.endTime,
                                      id: s.id,
                                      key: match !== undefined ? match : (
                                          match$1 !== undefined ? match$1 : V4()
                                        ),
                                      notes: s.notes,
                                      startTime: s.startTime,
                                      type_: s.typ
                                    };
                            });
                })), []),
      website: draftProperty.website,
      willAcceptOffers: draftProperty.willAcceptOffers,
      willShow: draftProperty.willShow
    };
  } else {
    tmp$1 = {
      address: undefined,
      addressToGeocode: undefined,
      availableFrom: undefined,
      baths: undefined,
      beds: undefined,
      commission: undefined,
      description: undefined,
      displayNeighborhood: undefined,
      files: [],
      forSalePropertyType: undefined,
      geocodingData: undefined,
      goingOnMls: undefined,
      halfBaths: undefined,
      hideAddress: undefined,
      images: [],
      leaseLength: undefined,
      livingArea: undefined,
      lotSize: undefined,
      maxPrice: undefined,
      minPrice: undefined,
      mlsListingType: "ACTIVE",
      numberOfUnits: undefined,
      onMlsAt: undefined,
      price: undefined,
      priceRange: false,
      propertyType: "FOR_SALE",
      rentalPropertyType: undefined,
      selectedArea: undefined,
      showings: [],
      website: undefined,
      willAcceptOffers: true,
      willShow: true
    };
  }
  return {
          chapterPreferenceMlsComingSoonActivated: tmp,
          draftProperty: tmp$1,
          message: serverDraft.message,
          serverDraftId: serverDraft.databaseId,
          status: serverDraft.status,
          subject: serverDraft.subject,
          timeZone: Core__Option.getOr(Core__Option.flatMap(serverDraft.chapter, (function (c) {
                      return c.timezone;
                    })), "")
        };
}

var convertVariables$1 = PropertyWizardFormRelayQuery_graphql.Internal.convertVariables;

var convertResponse$1 = PropertyWizardFormRelayQuery_graphql.Internal.convertResponse;

var convertWrapRawResponse$1 = PropertyWizardFormRelayQuery_graphql.Internal.convertWrapRawResponse;

var use$3 = RescriptRelay_Query.useQuery(convertVariables$1, PropertyWizardFormRelayQuery_graphql.node, convertResponse$1);

var useLoader$1 = RescriptRelay_Query.useLoader(convertVariables$1, PropertyWizardFormRelayQuery_graphql.node, (function (prim) {
        return prim;
      }));

var usePreloaded$1 = RescriptRelay_Query.usePreloaded(PropertyWizardFormRelayQuery_graphql.node, convertResponse$1, (function (prim) {
        return prim;
      }));

var $$fetch$1 = RescriptRelay_Query.$$fetch(PropertyWizardFormRelayQuery_graphql.node, convertResponse$1, convertVariables$1);

var fetchPromised$1 = RescriptRelay_Query.fetchPromised(PropertyWizardFormRelayQuery_graphql.node, convertResponse$1, convertVariables$1);

var retain$1 = RescriptRelay_Query.retain(PropertyWizardFormRelayQuery_graphql.node, convertVariables$1);

var commitLocalPayload$1 = RescriptRelay_Query.commitLocalPayload(PropertyWizardFormRelayQuery_graphql.node, convertVariables$1, convertWrapRawResponse$1);

var LocalDraftSetterQuery_draftV5Status_decode = PropertyWizardFormRelayQuery_graphql.Utils.draftV5Status_decode;

var LocalDraftSetterQuery_draftV5Status_fromString = PropertyWizardFormRelayQuery_graphql.Utils.draftV5Status_fromString;

var LocalDraftSetterQuery_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var LocalDraftSetterQuery_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var LocalDraftSetterQuery_leaseLengthValue_decode = PropertyWizardFormRelayQuery_graphql.Utils.leaseLengthValue_decode;

var LocalDraftSetterQuery_leaseLengthValue_fromString = PropertyWizardFormRelayQuery_graphql.Utils.leaseLengthValue_fromString;

var LocalDraftSetterQuery_localDraftPropertyType_decode = PropertyWizardFormRelayQuery_graphql.Utils.localDraftPropertyType_decode;

var LocalDraftSetterQuery_localDraftPropertyType_fromString = PropertyWizardFormRelayQuery_graphql.Utils.localDraftPropertyType_fromString;

var LocalDraftSetterQuery_mlsListingTypeV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.mlsListingTypeV5_decode;

var LocalDraftSetterQuery_mlsListingTypeV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.mlsListingTypeV5_fromString;

var LocalDraftSetterQuery_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var LocalDraftSetterQuery_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var LocalDraftSetterQuery_showingTypeV5_decode = PropertyWizardFormRelayQuery_graphql.Utils.showingTypeV5_decode;

var LocalDraftSetterQuery_showingTypeV5_fromString = PropertyWizardFormRelayQuery_graphql.Utils.showingTypeV5_fromString;

var LocalDraftSetterQuery = {
  draftV5Status_decode: LocalDraftSetterQuery_draftV5Status_decode,
  draftV5Status_fromString: LocalDraftSetterQuery_draftV5Status_fromString,
  forSalePropertyTypeEnumV5_decode: LocalDraftSetterQuery_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: LocalDraftSetterQuery_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: LocalDraftSetterQuery_leaseLengthValue_decode,
  leaseLengthValue_fromString: LocalDraftSetterQuery_leaseLengthValue_fromString,
  localDraftPropertyType_decode: LocalDraftSetterQuery_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: LocalDraftSetterQuery_localDraftPropertyType_fromString,
  mlsListingTypeV5_decode: LocalDraftSetterQuery_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: LocalDraftSetterQuery_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: LocalDraftSetterQuery_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: LocalDraftSetterQuery_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: LocalDraftSetterQuery_showingTypeV5_decode,
  showingTypeV5_fromString: LocalDraftSetterQuery_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse$1,
  use: use$3,
  useLoader: useLoader$1,
  usePreloaded: usePreloaded$1,
  $$fetch: $$fetch$1,
  fetchPromised: fetchPromised$1,
  retain: retain$1,
  commitLocalPayload: commitLocalPayload$1
};

function localDraftToCommitable(localDraft) {
  var match = localDraft.draftProperty;
  return {
          chapterPreferenceMlsComingSoonActivated: localDraft.chapterPreferenceMlsComingSoonActivated,
          draftProperty: {
            address: match.address,
            addressToGeocode: match.addressToGeocode,
            availableFrom: match.availableFrom,
            baths: match.baths,
            beds: match.beds,
            commission: match.commission,
            description: match.description,
            displayNeighborhood: match.displayNeighborhood,
            files: match.files,
            forSalePropertyType: match.forSalePropertyType,
            geocodingData: match.geocodingData,
            goingOnMls: match.goingOnMls,
            halfBaths: match.halfBaths,
            hideAddress: match.hideAddress,
            images: match.images,
            leaseLength: match.leaseLength,
            livingArea: match.livingArea,
            lotSize: match.lotSize,
            maxPrice: match.maxPrice,
            minPrice: match.minPrice,
            mlsListingType: match.mlsListingType,
            numberOfUnits: match.numberOfUnits,
            onMlsAt: match.onMlsAt,
            price: match.price,
            priceRange: match.priceRange,
            propertyType: match.propertyType,
            rentalPropertyType: match.rentalPropertyType,
            selectedArea: match.selectedArea,
            showings: match.showings,
            website: match.website,
            willAcceptOffers: match.willAcceptOffers,
            willShow: match.willShow
          },
          message: localDraft.message,
          serverDraftId: localDraft.serverDraftId,
          status: Core__Option.flatMap(localDraft.status, draftV5Status_decode),
          subject: localDraft.subject,
          timeZone: localDraft.timeZone,
          updatedAt: Caml_option.some(Scalars.DateTime.fromJsDate(new Date()))
        };
}

var context = React.createContext({
      mode: "New"
    });

function use$4() {
  return React.useContext(context);
}

var make = context.Provider;

var Provider = {
  make: make
};

var ModeContext = {
  context: context,
  use: use$4,
  Provider: Provider
};

function useSetDraft() {
  var data = use$3(undefined, "store-only", undefined, undefined);
  var environment = RescriptRelay.useEnvironmentFromContext();
  var setDraft = function (draft) {
    commitLocalPayload$1(environment, undefined, {
          localDraft: Core__Option.map(draft, localDraftToCommitable)
        });
  };
  return [
          data,
          setDraft
        ];
}

var convertVariables$2 = PropertyWizardFormRelayMutation_graphql.Internal.convertVariables;

var convertResponse$2 = PropertyWizardFormRelayMutation_graphql.Internal.convertResponse;

var convertWrapRawResponse$2 = PropertyWizardFormRelayMutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$2, PropertyWizardFormRelayMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var use$5 = RescriptRelay_Mutation.useMutation(convertVariables$2, PropertyWizardFormRelayMutation_graphql.node, convertResponse$2, convertWrapRawResponse$2);

var SaveDraftMutation_forSalePropertyTypeEnumV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.forSalePropertyTypeEnumV5_decode;

var SaveDraftMutation_forSalePropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.forSalePropertyTypeEnumV5_fromString;

var SaveDraftMutation_leaseLengthValue_decode = PropertyWizardFormRelayMutation_graphql.Utils.leaseLengthValue_decode;

var SaveDraftMutation_leaseLengthValue_fromString = PropertyWizardFormRelayMutation_graphql.Utils.leaseLengthValue_fromString;

var SaveDraftMutation_mlsListingTypeV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.mlsListingTypeV5_decode;

var SaveDraftMutation_mlsListingTypeV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.mlsListingTypeV5_fromString;

var SaveDraftMutation_rentalPropertyTypeEnumV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.rentalPropertyTypeEnumV5_decode;

var SaveDraftMutation_rentalPropertyTypeEnumV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.rentalPropertyTypeEnumV5_fromString;

var SaveDraftMutation_showingTypeV5_decode = PropertyWizardFormRelayMutation_graphql.Utils.showingTypeV5_decode;

var SaveDraftMutation_showingTypeV5_fromString = PropertyWizardFormRelayMutation_graphql.Utils.showingTypeV5_fromString;

var SaveDraftMutation = {
  forSalePropertyTypeEnumV5_decode: SaveDraftMutation_forSalePropertyTypeEnumV5_decode,
  forSalePropertyTypeEnumV5_fromString: SaveDraftMutation_forSalePropertyTypeEnumV5_fromString,
  leaseLengthValue_decode: SaveDraftMutation_leaseLengthValue_decode,
  leaseLengthValue_fromString: SaveDraftMutation_leaseLengthValue_fromString,
  mlsListingTypeV5_decode: SaveDraftMutation_mlsListingTypeV5_decode,
  mlsListingTypeV5_fromString: SaveDraftMutation_mlsListingTypeV5_fromString,
  rentalPropertyTypeEnumV5_decode: SaveDraftMutation_rentalPropertyTypeEnumV5_decode,
  rentalPropertyTypeEnumV5_fromString: SaveDraftMutation_rentalPropertyTypeEnumV5_fromString,
  showingTypeV5_decode: SaveDraftMutation_showingTypeV5_decode,
  showingTypeV5_fromString: SaveDraftMutation_showingTypeV5_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$2,
  convertResponse: convertResponse$2,
  convertWrapRawResponse: convertWrapRawResponse$2,
  commitMutation: commitMutation,
  use: use$5
};

function localDraftToDraftPropertyInput(draft) {
  var match = draft.draftProperty;
  var tmp;
  tmp = match.propertyType === "FOR_SALE" ? ({
        commission: match.commission,
        forSalePropertyType: match.forSalePropertyType
      }) : undefined;
  var match$1 = draft.draftProperty.geocodingData;
  var match$2 = draft.draftProperty;
  var tmp$1;
  tmp$1 = match$2.propertyType === "FOR_SALE" ? undefined : ({
        availableFrom: match$2.availableFrom,
        commission: match$2.commission,
        leaseLength: match$2.leaseLength,
        rentalPropertyType: match$2.rentalPropertyType
      });
  return {
          baths: draft.draftProperty.baths,
          beds: draft.draftProperty.beds,
          description: draft.draftProperty.description,
          displayNeighborhoodId: Core__Option.map(draft.draftProperty.displayNeighborhood, (function (dn) {
                  return dn.id;
                })),
          files: draft.draftProperty.files.map(function (file) {
                return {
                        contentType: file.contentType,
                        fileName: file.fileName,
                        id: file.id,
                        key: file.key
                      };
              }),
          forSaleProperty: tmp,
          geocodingData: match$1 !== undefined ? ({
                lat: match$1.lat,
                lon: match$1.lon,
                standardizedAddress: match$1.standardizedAddress,
                standardizedCity: match$1.standardizedCity,
                standardizedState: match$1.standardizedState,
                standardizedZip: match$1.standardizedZip
              }) : undefined,
          goingOnMls: draft.draftProperty.goingOnMls,
          halfBaths: draft.draftProperty.halfBaths,
          hideAddress: draft.draftProperty.hideAddress,
          images: draft.draftProperty.images.map(function (image) {
                return {
                        contentType: image.contentType,
                        fileName: image.fileName,
                        id: image.id,
                        key: image.key
                      };
              }),
          livingArea: draft.draftProperty.livingArea,
          lotSize: draft.draftProperty.lotSize,
          mlsListingType: draft.draftProperty.mlsListingType,
          numberOfUnits: draft.draftProperty.numberOfUnits,
          onMlsAt: draft.draftProperty.onMlsAt,
          price: {
            exactPrice: draft.draftProperty.priceRange ? undefined : ({
                  price: Core__Option.map(draft.draftProperty.price, Scalars.PriceInput.fromInt)
                }),
            priceRange: draft.draftProperty.priceRange ? ({
                  maxPrice: Core__Option.map(draft.draftProperty.maxPrice, Scalars.PriceInput.fromInt),
                  minPrice: Core__Option.map(draft.draftProperty.minPrice, Scalars.PriceInput.fromInt)
                }) : undefined
          },
          rentalProperty: tmp$1,
          selectedAreaId: Core__Option.map(draft.draftProperty.selectedArea, (function (area) {
                  return area.id;
                })),
          showings: draft.draftProperty.showings.map(function (s) {
                return {
                        date: s.date,
                        endTime: s.endTime,
                        id: s.id,
                        key: s.key,
                        notes: s.notes,
                        startTime: s.startTime,
                        type: s.type_
                      };
              }),
          streetAddress: draft.draftProperty.address,
          website: draft.draftProperty.website,
          willAcceptOffers: draft.draftProperty.willAcceptOffers,
          willShow: draft.draftProperty.willShow
        };
}

var saveDraftMutationDisposables = {
  contents: []
};

var saveDraftMutationTimeout = {
  contents: undefined
};

function useSaveLocalProperty() {
  var formContext = React.useContext(context);
  var match = use$5();
  var saveDraft = match[0];
  var match$1 = useSetDraft();
  var setDraft = match$1[1];
  var updateFormState = useUpdater();
  var preloadPreviewQuery = PropertyWizardRelay__Preview__Query.usePreloadPreviewQuery();
  var draftId = Core__Option.flatMap(match$1[0].localDraft, (function (ld) {
          return ld.serverDraftId;
        }));
  var saveDraft$1 = function (draft) {
    updateFormState(function (fs) {
          var match = fs.draftSaveStatus;
          var tmp;
          tmp = match === "NotSaved" ? "FirstSaveInProgress" : "SaveInProgress";
          fs.draftSaveStatus = tmp;
        });
    var propertyInput = localDraftToDraftPropertyInput(draft);
    var match = formContext.mode;
    var propertyIdForDraft;
    if (draftId !== undefined || typeof match !== "object") {
      propertyIdForDraft = undefined;
    } else {
      switch (match.TAG) {
        case "Edit" :
            propertyIdForDraft = undefined;
            break;
        case "Rebroadcast" :
        case "BroadcastQuietSeller" :
            propertyIdForDraft = match._0;
            break;
        
      }
    }
    var disposableFromSave = saveDraft({
          input: {
            draftId: draftId,
            message: draft.message,
            property: propertyInput,
            propertyId: propertyIdForDraft,
            subject: draft.subject
          }
        }, undefined, undefined, undefined, (function (response, _mutationErrors) {
            updateFormState(function (fs) {
                  fs.draftSaveStatus = "Saved";
                });
            var saveListingDraftV5 = response.saveListingDraftV5;
            if (saveListingDraftV5 !== undefined) {
              setDraft(serverDraftToLocalDraft(readInline$1(saveListingDraftV5.fragmentRefs)));
            }
            preloadPreviewQuery(propertyInput);
          }), (function (_mutationError) {
            updateFormState(function (fs) {
                  fs.draftSaveStatus = "SaveFailed";
                });
          }), undefined);
    saveDraftMutationDisposables.contents.forEach(function (prim) {
          prim.dispose();
        });
    saveDraftMutationDisposables.contents = [disposableFromSave];
  };
  var saveDraft$2 = function (localDraft) {
    saveDraftMutationDisposables.contents.forEach(function (prim) {
          prim.dispose();
        });
    saveDraftMutationDisposables.contents = [];
    var timeoutId = saveDraftMutationTimeout.contents;
    if (timeoutId !== undefined) {
      clearTimeout(Caml_option.valFromOption(timeoutId));
      saveDraftMutationTimeout.contents = undefined;
    }
    saveDraftMutationTimeout.contents = Caml_option.some(setTimeout((function () {
                saveDraft$1(localDraft);
                saveDraftMutationTimeout.contents = undefined;
              }), 750));
  };
  var match$2 = formContext.mode;
  if (typeof match$2 !== "object" || match$2.TAG !== "Edit") {
    return saveDraft$2;
  } else {
    return function (draft) {
      var propertyInput = localDraftToDraftPropertyInput(draft);
      preloadPreviewQuery(propertyInput);
    };
  }
}

function composeUpdaters(updaters) {
  return function (draftProperty) {
    return Core__Array.reduce(updaters, draftProperty, (function (draftProperty, updater) {
                  return updater(draftProperty);
                }));
  };
}

var context$1 = React.createContext({
      scheduleUpdate: (function (param) {
          
        })
    });

function use$6() {
  return React.useContext(context$1);
}

var make$1 = context$1.Provider;

var Provider_ = {
  make: make$1
};

function PropertyWizardFormRelay$UpdaterContext$Provider(props) {
  var match = useSetDraft();
  var setDraft = match[1];
  var data = match[0];
  var saveDraft = useSaveLocalProperty();
  var draft = useOpt(Core__Option.map(data.localDraft, (function (l) {
              return l.fragmentRefs;
            })));
  var mostRecentDraftData = React.useRef(draft);
  mostRecentDraftData.current = draft;
  var match$1 = React.useState(function () {
        return [];
      });
  var setPendingUpdates = match$1[1];
  var pendingUpdates = match$1[0];
  var match$2 = React.useState(function () {
        return false;
      });
  var setIsWaitingForPropagation = match$2[1];
  var isWaitingForPropagation = match$2[0];
  React.useEffect((function () {
          if (pendingUpdates.length > 0 && !isWaitingForPropagation) {
            var updater = composeUpdaters(pendingUpdates);
            var currentDraft = mostRecentDraftData.current;
            var newDraft = currentDraft !== undefined ? updater(currentDraft) : undefined;
            setIsWaitingForPropagation(function (param) {
                  return true;
                });
            setPendingUpdates(function (u) {
                  return u.filter(function (u) {
                              return pendingUpdates.every(function (u_) {
                                          return u !== u_;
                                        });
                            });
                });
            setDraft(newDraft);
            if (newDraft !== undefined) {
              saveDraft(newDraft);
            }
            
          }
          
        }), [
        pendingUpdates,
        isWaitingForPropagation
      ]);
  React.useEffect((function () {
          setIsWaitingForPropagation(function (param) {
                return false;
              });
        }), [Core__Option.map(data.localDraft, (function (x) {
                return x.updatedAt;
              }))]);
  return JsxRuntime.jsx(make$1, {
              value: {
                scheduleUpdate: (function (updater) {
                    setPendingUpdates(function (pendingUpdates) {
                          return pendingUpdates.concat([updater]);
                        });
                  })
              },
              children: props.children
            });
}

var Provider$1 = {
  make: PropertyWizardFormRelay$UpdaterContext$Provider
};

var UpdaterContext = {
  context: context$1,
  use: use$6,
  Provider_: Provider_,
  Provider: Provider$1
};

function useUpdateDraft() {
  return React.useContext(context$1).scheduleUpdate;
}

function use$7() {
  return React.useContext(context);
}

function PropertyWizardFormRelay$Context$Provider(props) {
  return JsxRuntime.jsx(make, {
              value: {
                mode: props.mode
              },
              children: JsxRuntime.jsx(PropertyWizardFormRelay$UpdaterContext$Provider, {
                    children: props.children
                  })
            });
}

var Provider$2 = {
  make: PropertyWizardFormRelay$Context$Provider
};

var Context = {
  use: use$7,
  Provider: Provider$2
};

function useUpdateDraftProperty() {
  var match = React.useContext(context$1);
  var scheduleUpdate = match.scheduleUpdate;
  return function (updater) {
    scheduleUpdate(function (draft) {
          return {
                  chapterPreferenceMlsComingSoonActivated: draft.chapterPreferenceMlsComingSoonActivated,
                  draftProperty: updater(draft.draftProperty),
                  message: draft.message,
                  serverDraftId: draft.serverDraftId,
                  status: draft.status,
                  subject: draft.subject,
                  timeZone: draft.timeZone
                };
        });
  };
}

function getEmptyLocalDraft(draftId, defaultTimezone) {
  return {
          chapterPreferenceMlsComingSoonActivated: false,
          draftProperty: {
            address: undefined,
            addressToGeocode: undefined,
            availableFrom: undefined,
            baths: undefined,
            beds: undefined,
            commission: undefined,
            description: undefined,
            displayNeighborhood: undefined,
            files: [],
            forSalePropertyType: undefined,
            geocodingData: undefined,
            goingOnMls: undefined,
            halfBaths: undefined,
            hideAddress: undefined,
            images: [],
            leaseLength: undefined,
            livingArea: undefined,
            lotSize: undefined,
            maxPrice: undefined,
            minPrice: undefined,
            mlsListingType: "ACTIVE",
            numberOfUnits: undefined,
            onMlsAt: undefined,
            price: undefined,
            priceRange: false,
            propertyType: "FOR_SALE",
            rentalPropertyType: undefined,
            selectedArea: undefined,
            showings: [],
            website: undefined,
            willAcceptOffers: true,
            willShow: true
          },
          message: undefined,
          serverDraftId: draftId,
          status: undefined,
          subject: undefined,
          timeZone: defaultTimezone
        };
}

function useInitForm(draftData, draftDbId, param) {
  var match = React.useState(function () {
        return false;
      });
  var setInitialized = match[1];
  var match$1 = React.useContext(context);
  var mode = match$1.mode;
  var defaultTimezone = DateFnsTz.Timezone.toString(UserSession.useChapterTimezone());
  var environment = RescriptRelay.useEnvironmentFromContext();
  var updateFormState = useUpdater();
  var match$2 = useSetDraft();
  var setDraft = match$2[1];
  React.useEffect((function () {
          var draftData$1 = draftData !== undefined ? draftData : getEmptyLocalDraft(draftDbId, defaultTimezone);
          setDraft(draftData$1);
          var stepsInitiallyTouched;
          if (typeof mode !== "object") {
            stepsInitiallyTouched = false;
          } else {
            switch (mode.TAG) {
              case "Edit" :
              case "Rebroadcast" :
                  stepsInitiallyTouched = true;
                  break;
              case "BroadcastQuietSeller" :
                  stepsInitiallyTouched = false;
                  break;
              
            }
          }
          commitLocalPayload(environment, undefined, {
                localDraftFormState: {
                  __typename: "LocalDraftFormState"
                }
              });
          updateFormState(function (formState) {
                formState.stepDescriptionTouched = stepsInitiallyTouched;
                formState.stepKeyFactsTouched = stepsInitiallyTouched;
                formState.stepMlsTimingTouched = stepsInitiallyTouched;
                formState.stepShowingsTouched = stepsInitiallyTouched;
                formState.stepPhotosAndFilesTouched = stepsInitiallyTouched;
                formState.filesStatus = [];
                formState.imagesStatus = [];
                setDisplayNeighborhoods(formState, []);
              });
          setInitialized(function (param) {
                return true;
              });
        }), []);
  return match[0];
}

var PreviewQuery;

exports.PolicyFragment = PolicyFragment;
exports.FormState = FormState;
exports.LocalDraftFragment = LocalDraftFragment;
exports.ServerDraftFragment = ServerDraftFragment;
exports.InlineServerDraftFragment = InlineServerDraftFragment;
exports.serverDraftToLocalDraft = serverDraftToLocalDraft;
exports.LocalDraftSetterQuery = LocalDraftSetterQuery;
exports.localDraftToCommitable = localDraftToCommitable;
exports.ModeContext = ModeContext;
exports.useSetDraft = useSetDraft;
exports.SaveDraftMutation = SaveDraftMutation;
exports.localDraftToDraftPropertyInput = localDraftToDraftPropertyInput;
exports.PreviewQuery = PreviewQuery;
exports.saveDraftMutationDisposables = saveDraftMutationDisposables;
exports.saveDraftMutationTimeout = saveDraftMutationTimeout;
exports.useSaveLocalProperty = useSaveLocalProperty;
exports.composeUpdaters = composeUpdaters;
exports.UpdaterContext = UpdaterContext;
exports.useUpdateDraft = useUpdateDraft;
exports.Context = Context;
exports.useUpdateDraftProperty = useUpdateDraftProperty;
exports.getEmptyLocalDraft = getEmptyLocalDraft;
exports.useInitForm = useInitForm;
/* use Not a pure module */
